module.exports = __webpack_public_path__ + "static/media/appointment.6c7f211d.svg";